import { DecimalPipe as AngularDecimalPipe, CurrencyPipe, PercentPipe, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";

import { DecimalPipe } from "../pipe/decimal.pipe";
import { MoneyPipe } from "../pipe/money.pipe";
import { PercentagePipe } from "../pipe/percentage.pipe";
import { TimestampPipe } from "../pipe/timestamp.pipe";
import { LogPipe } from "../pipe/console-log.pipe";
import { SplitLastPipe } from "../pipe/split.pipe";

/**
 * @description
 *  Módulo principal de pipes.
 */

@NgModule({
	declarations: [
		DecimalPipe,
		MoneyPipe,
		PercentagePipe,
		TimestampPipe,
		LogPipe,
		SplitLastPipe
	],
	exports: [
		DecimalPipe,
		MoneyPipe,
		PercentagePipe,
		TimestampPipe,
		LogPipe,
		SplitLastPipe
	],
	imports: [],
	providers: [
		AngularDecimalPipe,
		CurrencyPipe,
		DatePipe,
		PercentPipe
	]
})
export class PipeModule { }
